export default "__VITE_ASSET__3f9c4e3f__"